import {
  makeStyles,
  TableCellLayout,
  Tooltip,
} from "@fluentui/react-components";
import { ArrowSync12Regular } from "@fluentui/react-icons";
import { Translation } from "react-i18next";
import { Link } from "react-router-dom";
import { FieldTypes } from "../../models/FieldTypes";
import { SkanskaColorTokens } from "../../style/colors";
import { DisplayField } from "../DisplayField";
import { IItemMetadata } from "./GenericDataGrid";

const useStyles = makeStyles({
  itemTitle: {
    textDecoration: "none",
    fontWeight: "600",
    color: SkanskaColorTokens.color_action_blue,
    overflowWrap: "break-word",
    display: "block",
    flex: 1,
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  titleWithIcon: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
  },
  mirroredIcon: {
    marginLeft: "8px",
    display: "flex",
  },
});

interface ToolActivitiesDataGridCellProps {
  item: IItemMetadata;
  route: string;
}

const TitleDataGridCell = (props: ToolActivitiesDataGridCellProps) => {
  const { item, route } = props;
  const classes = useStyles();

  return (
    <Translation>
      {(t) => (
        <TableCellLayout>
          <span className={classes.titleWithIcon}>
            <Link
              to={route ?? ""}
              className={classes.itemTitle}
              target="_blank"
              rel="noopener noreferrer"
            >
              <DisplayField
                type={FieldTypes.Text}
                label={t("title")}
                value={item.title}
              />
            </Link>
            {item.mirroredActivityId != null && (
              <Tooltip content={t("mirroredActivity")} relationship="label">
                <span className={classes.mirroredIcon}>
                  <ArrowSync12Regular />
                </span>
              </Tooltip>
            )}
          </span>
        </TableCellLayout>
      )}
    </Translation>
  );
};

export default TitleDataGridCell;
